import React, { useState } from "react";
import "./directorsPage.css";
import { Link } from "react-router-dom";

const directors = [
  {
    name: "ÇAĞ ÇALIŞKUR",
    role: "Director",
    description: "Çağ Çalışkur has directed numerous successful commercials and short films.",
    images: ["/images/cag1.jpg", "/images/cag2.jpg"],
  },
  {
    name: "ÇAĞRI ARK",
    role: "Director",
    description: `Çağrı, yeni ufuklar açan yaratıcı fikirler üzerinde çalışmayı seven bir Fransızca konuşan yönetmendir.
Galatasaray Lisesi’nden mezun olduktan sonra sinema eğitimi almak için Fransa’ya gitmiştir.
Türkiye’ye döndüğünde, Turkish Airlines için dünya çapında projelerde ajans yapımcısı olarak çalıştı. Aynı zamanda Turkish Airlines - Kobe vs Messi adlı en çok izlenen reklamın ekibinde yer aldı.
Daha sonra tüm bilgi ve deneyimini tam zamanlı yönetmen olarak kullanmaya karar verdi. Pepsi, Tropicana, Varyap gibi tanınmış yerel ve uluslararası markalar için birçok reklam yönetmenliği yapmıştır.
Çağrı’nın Fiat için hazırladığı Babalar Günü projesi 2014 yılında bir Kristal Elma ödülü kazandı.
Yeni hikayeler anlatmak için sabırsızlanıyor ve yaratıcı projeler geliştirmesiyle tanınıyor.`,
    images: ["/images/cagri1.jpg", "/images/cagri2.jpg"],
  },
  {
    name: "ŞENOL ALTUN",
    role: "Director",
    description: "Şenol Altun is a multi-talented director and cinematographer.",
    images: ["/images/senol1.jpg", "/images/senol2.jpg"],
  },
  {
    name: "UTKU ATALAY",
    role: "Director",
    description: "Utku Atalay is an award-winning director specializing in independent films.",
    images: ["/images/utkk.png"],
  }
  
  // {
  //   name: "VOLKAN HİÇYILMAZ",
  //   role: "Director",
  //   description: "Volkan İçyılmaz is a director with a unique approach to storytelling.",
  //   images: ["/images/volkan1.jpg", "/images/volkan2.jpg"],
  // },
];

const convertToSlug = (str) => {
  const map = {
    ç: "c",
    Ç: "C",
    ş: "s",
    Ş: "S",
    ı: "i",
    İ: "I",
    ü: "u",
    Ü: "U",
    ö: "o",
    Ö: "O",
    ğ: "g",
    Ğ: "G",
  };
  return str
    .split("")
    .map((char) => map[char] || char) // Eğer karakter eşleşiyorsa değiştir, yoksa olduğu gibi bırak
    .join("")
    .toLowerCase()
    .replace(/ /g, "-"); // Boşlukları da tireye çevir
};


const DirectorsPage = () => {
  const [selectedDirector, setSelectedDirector] = useState(null);

  return (
    <div className="directors-page">
      <div className="director-names">
        {directors.map((director) => (
          <Link
          key={director.name}
          to={`/directors/${convertToSlug(director.name)}`} // Dinamik rota
          className={`director-name ${
            selectedDirector === director.name ? "filled" : "outlined"
          }`}
          onMouseEnter={() => setSelectedDirector(director.name)}
          onMouseLeave={() => setSelectedDirector(null)}
        >
          {director.name}
        </Link>
        ))}
      </div>
      {/* <div className="director-images">
        {selectedDirector &&
          directors
            .find((d) => d.name === selectedDirector)
            ?.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={selectedDirector}
                className="director-image"
              />
            ))}
      </div> */}
    </div>
  );
};

export default DirectorsPage;
